import { FC } from 'react';
import { ButtonProps } from '@chakra-ui/react';
import router from 'next/router';
import { ICON_BY_NAME } from 'ui/components/Icons/Icon';
import { useCurrentUser } from '../../hooks/useCurrentUser';
import { CbButton } from 'ui/components/Buttons/CbButton';
export const setRedirectLinks = () => {
  localStorage.setItem('routeBeforeRedirect', router.asPath);
};
export interface GroupMeWidgetProps extends ButtonProps {
  showIfConnected?: boolean;
}
export const GroupMeWidget: FC<GroupMeWidgetProps> = ({
  showIfConnected,
  ...props
}) => {
  const GROUPME_DISTRIBUTION_URL = process.env.GROUPME_DISTRIBUTION_URL;
  const currentUser = useCurrentUser();
  const needsToConnectGroupMe = currentUser?.needsToConnectGroupMe;
  const buttonText = showIfConnected ? 'Reconnect to GroupMe' : 'Connect to GroupMe';
  if (needsToConnectGroupMe) {
    return <CbButton borderWidth={{
      xl: '4px'
    }} borderColor="white" onClick={() => setRedirectLinks()} href={GROUPME_DISTRIBUTION_URL} width={{
      base: '100%',
      xl: 'auto'
    }} marginTop={{
      base: '4',
      xl: '0'
    }} {...props} variant="danger">
        <ICON_BY_NAME.link marginRight={2} />
        {buttonText}
      </CbButton>;
  } else if (showIfConnected) {
    return <CbButton onClick={() => setRedirectLinks()} href={GROUPME_DISTRIBUTION_URL} {...props} variant="primary">
        <ICON_BY_NAME.link marginRight={2} />
        {buttonText}
      </CbButton>;
  }
  return <></>;
};